import { createTheme } from "@mui/material/styles";
import "@mui/x-data-grid/themeAugmentation";

export default createTheme({
  palette: {
    primary: {
      main: "#00AFF2",
    },
    DataGrid: {
      headerBg: "var(--gray-100)",
    },
  },
  components: {
    // Name of the component
    MuiButton: {
      styleOverrides: {
        // Name of the slot
        root: {
          // Some CSS
          // fontSize: "1rem",
          color: "var(--white)",
        },
      },
    },
  },
});
